import { createTheme } from "@mui/material/styles";
import React from "react";
import { Grid, ThemeProvider, StyledEngineProvider } from "@mui/material";
import { ShiftStateProvider } from "./context";
import FrequencyForm from "./FrequencyForm";
import theme from "../../volunteer_dashboard/domains/global/theme.json";

const FrequencyFormComponent = ({ date, start, end, rrule }) => (
  <ShiftStateProvider>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={createTheme(theme)}>
        <Grid container spacing={3}>
          <FrequencyForm
            startingValues={{
              date,
              start,
              end,
              rrule,
            }}
            hiddenFields
          />
        </Grid>
      </ThemeProvider>
    </StyledEngineProvider>
  </ShiftStateProvider>
);

export default FrequencyFormComponent;
